import { Modal, ModalBody, ModalContent } from "@heroui/react";
import { CountdownTimer } from "./CountdownTimer";

interface WaitingModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  txHash?: string;
  showCountdown?: boolean;
  countdownDuration?: number;
}

export function WaitingModal({
  isOpen,
  onClose,
  title,
  description = "The transaction is being processed. You can stay or close the modal and we will notify you when the transaction is complete.",
  txHash,
  showCountdown = false,
  countdownDuration = 15 * 60,
}: WaitingModalProps) {
  const formatTxHash = (hash: string) => {
    if (hash.length <= 13) return hash;
    return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="text-center p-8 space-y-4">
          {showCountdown && (
            <div>
              <CountdownTimer duration={countdownDuration} />
            </div>
          )}
          <div className="space-y-2">
            <p className="font-semibold text-large">{title}</p>
            <p className="text-small text-[#AEC4D3]">{description}</p>
          </div>
          {txHash && (
            <div className="text-small text-[#AEC4D3]">
              <p>
                Transaction hash: <span className="text-white font-normal">{formatTxHash(txHash)}</span>
              </p>
            </div>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}